import { forwardRef, type Ref, type SVGProps } from "react";
const IconFireplaceOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M16 2C8.268 2 2 8.2 2 15.85v9.188c0 .531.436.962.972.962h26.056c.536 0 .972-.43.972-.962V15.85C30 8.2 23.732 2 16 2M3.944 15.85C3.944 9.263 9.342 3.924 16 3.924s12.056 5.34 12.056 11.926v8.226h-7.103a6.8 6.8 0 0 0 1.797-2.33 6.7 6.7 0 0 0 .639-2.863c0-2.224-1.318-3.792-2.453-5.142l-.296-.354c-1.238-1.492-2.307-2.958-2.307-5.276a.95.95 0 0 0-.365-.751.98.98 0 0 0-.82-.187c-1.748.39-2.81 1.245-3.396 2.334-.553 1.025-.618 2.15-.648 2.936l-.008.264c-.006.18-.012.332-.02.465a8 8 0 0 1-.82-.479.96.96 0 0 0-1.193.098h-.002l-.001.002-.004.003-.009.01a6 6 0 0 0-.404.432 8.4 8.4 0 0 0-.833 1.184 8.8 8.8 0 0 0-1.199 4.46c0 .99.219 1.967.64 2.864a6.8 6.8 0 0 0 1.8 2.33H3.943zm6.612 3.033a6.9 6.9 0 0 1 1.362-4.14q.423.24.887.392c.461.14 1.107.201 1.624-.263.425-.382.518-.932.557-1.236.035-.279.045-.61.054-.913v-.004l.008-.205c.029-.784.098-1.505.42-2.103.187-.347.485-.698 1.019-.98.347 2.288 1.56 3.862 2.65 5.177l.215.26c1.228 1.473 2.092 2.513 2.092 4.015 0 2.619-2.131 5.001-5.44 5.001-3.312 0-5.448-2.384-5.448-5.001M6 28a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFireplaceOutlineSVG);
ForwardRef.displayName = "IconFireplaceOutline";
export { ForwardRef as IconFireplaceOutline };
